export default "__VITE_ASSET__B5QMJq63__"